import styled, { css } from 'styled-components';
import { mediaMixin } from '@zillow/constellation';

// TODO: should be abstracted into own component -- used on PriceMyRental as well
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: white;
`;

// TODO: should be abstracted into own component -- used on PriceMyRental as well
export const Content = styled.main`
    width: 100%;
    max-width: 1280px;

    ${mediaMixin(
        'md',
        css`
            padding: 32px;
        `
    )};
`;

export const Emphasize = styled.span`
    font-weight: 600;
`;
